<template>
  <div class="c2c_sheet">
    <div class="c2c_head">
      <div class="head_left">
        <div class="left_title">{{ $t('C2C用户交易') }}</div>
        <p>{{ $t('C2C用户交易desc') }}</p>
      </div>
      <div class="head_right" @click="close">
        <van-icon name="cross" color="#31e2a5" size="16" />
      </div>
    </div>
    <van-tabs class="c2c_tab" line-height="0" swipe-threshold="2.5" v-model="active" animated background="transparent">
      <van-tab :title-class="[index == active ? 'tab_item item_active' : 'tab_item']" v-for="(item, index) in tabList"
        :title="$t(item)" :key="index" />
    </van-tabs>
    <template v-if="active == 0">
      <Market :key="keyNum" />
    </template>
    <template v-if="active == 1">
      <PostOffer :key="keyNum" />
    </template>
    <template v-if="active == 2">
      <MyTrade :key="keyNum" />
    </template>
    <template v-if="active == 3">
      <MyOrder :key="keyNum" />
    </template>
  </div>
</template>
<script>
import MyTrade from "./my_trade.vue";
import PostOffer from "./post_offer.vue";
import { Icon, List, Tab, Tabs } from "vant";
import { post } from "@/utils/newRequest";
import { mapGetters } from "vuex";
import { C2C_ORDER_TAKE } from "@/api"
import Market from "./market.vue"
import MyOrder from "./my_order.vue";
export default {
  components: {
    [Icon.name]: Icon,
    List,
    MyTrade,
    PostOffer,
    Market,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    MyOrder
  },
  props: {
    keyNum: Number
  },
  data() {
    return {
      tabList: ['交易市場', '发布挂单', '我的交易', '我的订单'],
      active: 0,
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    tabActive(index) {
      if (this.active == index) return;
      this.active = index;
    },
    close() {
      this.$emit('close')
    }
  }

}
</script>
<style lang="less" scoped>
.c2c_sheet {
  padding: 18px 16px;
  background: #f7f9fc;
  max-height: calc(90vh - 36px);
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &::-webkit-scrollbar {
    display: none;
  }

  .c2c_head {
    display: grid;
    grid-template-columns: 1fr 36px;
    gap: 12px;

    .head_left {
      .left_title {
        color: #111827;
        font-size: 20px;
        font-weight: 900;
      }

      p {
        margin: 6px 0 0;
        color: #697386;
        font-size: 13px;
        line-height: 1.5;
      }
    }

    .head_right {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: #fff;
      box-shadow: 0 8px 16px #0f172a0f;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .c2c_tab {

    // display: grid;
    // grid-template-columns: repeat(3, minmax(0, 1fr));
    // gap: 8px;
    :deep(.van-tabs__nav) {
      gap: 8px;
    }

    :deep(.tab_item) {
      height: 38px;
      border: 1px solid rgba(15, 23, 42, .08);
      border-radius: 12px;
      background: #fff;
      color: #667085;
      font-size: 13px;
      font-weight: 900;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    :deep(.item_active) {
      border-color: #31e2a55c;
      background: #31e2a524;
      color: #31e2a5;
    }
  }
}
</style>